/**
 * Base entity model. All Apollon models should inherit this class.
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel'
import { BaseCollection } from './BaseCollection'
import type { MutationsObject } from '@kp/js-model'
import dayjs from 'dayjs'
import { getI18n } from '@/helpers/i18n'

export type Status = {
    text: string
    icon: string
    color: string
}

export class TeamMitglied extends BaseModel {
    id: number | null = null
    benutzer_id: number | null = null
    team_id: number | null = null
    status: string | null = null
    created: number | null = null
    modified: number | null = null

    // View props:
    team_ersteller_id: number | null = null
    team_name: number | null = null
    benutzer_email: number | null = null
    team_mitglied_name: number | null = null
    ersteller_name: number | null = null

    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            benutzer_id: (id) => (Number(id) > 0 ? Number(id) : null),
            team_ersteller_id: (id) => (Number(id) > 0 ? Number(id) : null),
            team_id: (id) => (Number(id) > 0 ? Number(id) : null),
            created: dayjs,
            modified: dayjs,
        }
    }

    get status_display(): Status {
        const s: { [key: string]: Status } = {
            none: { text: '-', icon: '', color: '' },
            accepted: { text: getI18n().t('accepted'), icon: 'fas fa-check', color: 'success' },
            pending: { text: getI18n().t('pending'), icon: 'far fa-hourglass', color: 'warning' },
            declined: { text: getI18n().t('declined'), icon: 'fas fa-times', color: 'error' },
        }
        if (!this.status) {
            return s['none']
        }
        return this.status in s ? s[this.status] : s['none']
    }

    getClassName(): string {
        return 'team_mitglied'
    }
}

export class TeamMitgliedCollection extends BaseCollection<TeamMitglied> {
    protected modelCls = TeamMitglied

    public getModelClassName(): string {
        return 'team_mitglied'
    }
}
